<ng-container *transloco="let t">
  <button
    type="button"
    data-test-id="lang-selector.en-btn"
    [attr.aria-pressed]="currentLang === 'en'"
    (click)="onSelectLanguage('en')"
    class="LanguageSelector font-PoppinsMedium text-b3"
    [class.activeLanguage]="currentLang === 'en'"
  >
    {{ t('common.english') }}
  </button>
  <span class="font-PoppinsRegular text-ls_primary_navy text-b3"> | </span>
  <button
    type="button"
    data-test-id="lang-selector.fr-btn"
    [attr.aria-pressed]="currentLang === 'fr'"
    (click)="onSelectLanguage('fr')"
    class="LanguageSelector font-PoppinsMedium text-b3"
    [class.activeLanguage]="currentLang === 'fr'"
  >
    {{ t('common.french') }}
  </button>
</ng-container>
